import script from "./FormImage.vue?vue&type=script&setup=true&lang=js"
export * from "./FormImage.vue?vue&type=script&setup=true&lang=js"

import "./FormImage.vue?vue&type=style&index=0&id=68042b9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68042b9c"]])

export default __exports__